import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { PaymentStatusEnum } from '@app/core/services/transaction/model/enum/payment-status.enum';
import { Order } from '@app/core/services/transaction/model/order.model';
import { Transaction } from '@app/core/services/transaction/model/transaction.model';
import { RecoverExternallyModalComponent } from './recover-externally-modal/recover-externally-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PaymentType } from '@app/core/services/transaction/model/enum/payment-type.enum';
import { TransactionService } from '@app/core/services/transaction/transaction.service';
import { NotificationService } from '@app/core/services/util/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ap-transaction-details-content',
  templateUrl: './transaction-details-content.component.html',
  styleUrls: ['./transaction-details-content.component.css'],
  standalone: false
})
export class TransactionDetailsContentComponent implements OnInit {

  Permissions = PermissionEnum;
  PaymentStatus = PaymentStatusEnum;
  PaymentType = PaymentType;

  @Input() transaction: Transaction;
  @Input() order: Order;
  @Input() userView = false;

  constructor(private router: Router, public dialog: MatDialog, private transactionService: TransactionService, private notificationService: NotificationService, private translateService: TranslateService) {
  }

  ngOnInit(): void {
  }

  backToTransactions() {
    if (this.userView) {
      const url = sessionStorage.getItem('from_user_tabs');
      const filterState = sessionStorage.getItem('filter_on');
      filterState == 'true' ? this.router.navigate([url], { queryParams: { filter: 'on' } }) : this.router.navigate([url]);
    }
  }

  navigateToUser(mobilityAccountId: number) {
    this.router.navigate(['/users', mobilityAccountId, 'all']);
  }

  openRecoverExternallyDialog() {
    const dialogRef = this.dialog.open(RecoverExternallyModalComponent, {
      panelClass: 'modal',
      width: '40%'
    })

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        const transactionRequest = Object.assign({}, this.transaction);
        transactionRequest.comment = data.comment;
        transactionRequest.status = PaymentStatusEnum.RECOVERED;
        transactionRequest.statusDetail = 'RECOVERED_EXTERNALLY';

        this.transactionService.updateTransactionExternalRegularizationById(this.transaction.paymentId, transactionRequest).subscribe({
          next: (transactionUpdated: Transaction) => {
            if (transactionUpdated) {
              this.transaction = transactionUpdated;
              this.notificationService.notify('success', this.translateService.instant('TRANSACTIONS.TRANSACTION_DETAILS.RECOVER_EXTERNALLY_MODAL.TOAST.SUCCESS'));
            }
          },
          error: _err => {
            this.notificationService.notify('error', this.translateService.instant('TRANSACTIONS.TRANSACTION_DETAILS.RECOVER_EXTERNALLY_MODAL.TOAST.ERROR'));
          }
        });
      }
    });
  }
}
